import { render, staticRenderFns } from "./manureRight1.vue?vue&type=template&id=0478e6d9&scoped=true&"
import script from "./manureRight1.vue?vue&type=script&lang=js&"
export * from "./manureRight1.vue?vue&type=script&lang=js&"
import style0 from "./manureRight1.vue?vue&type=style&index=0&id=0478e6d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478e6d9",
  null
  
)

export default component.exports